import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';

const useStyles = buildUseStyles('RelationshipLinkButton', ((theme) => ({
  root: {
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': {
      backgroundColor: 'initial',
    },
  },
})));

const RelationshipLinkButton = ({ relationship, onClick }) => {
  const classes = useStyles();

  return (
    <Button1
      className={classes.root}
      onClick={onClick}
      color={'primary'}
      variant={'underlined'}
      padding={'default'}
      size={'lg'}
    >
      {`${relationship.meta('prompt')}`}
    </Button1>
  );
};

RelationshipLinkButton.propTypes = {
  relationship: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RelationshipLinkButton;
